import React from "react"

import { SectionTitle, SectionWrapper } from "../styles/Table.styled"

import PackageTableRow from "./PackageTableRow"

const PackageTableSection = ({ sectionTitle, sectionRows }) => {
  return (
    <SectionWrapper>
      {sectionTitle && (
        <tr>
          <SectionTitle colSpan="6">{sectionTitle}</SectionTitle>
        </tr>
      )}
      {sectionRows?.length > 0 &&
        sectionRows?.map((sectionRow) => (
          <PackageTableRow
            key={sectionRow?.id}
            rowTitle={sectionRow?.rowTitle}
            rowCells={sectionRow?.rowCells}
          />
        ))}
    </SectionWrapper>
  )
}

export default PackageTableSection
